import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]

import { ref, onMounted, PropType } from 'vue';
import { Row, Col } from 'ant-design-vue';
import { channelList, IChannelItem, CHANNEL, ORDER_PAGE_STATUS, OrderInfo } from '../utils/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'Unpaid',
  props: {
  orderData: {
    type: Object as PropType<OrderInfo>,
    required: true,
  },

  changePaymentStatus: {
    type: Function as PropType<(status: ORDER_PAGE_STATUS, channelId: CHANNEL) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const currentChannelList = ref<IChannelItem[]>([]);

// 去支付
const toPay = (channelId: CHANNEL) => {
  props.changePaymentStatus(ORDER_PAGE_STATUS.INPAYMENT, channelId);
};

onMounted(() => {
  // 组装渠道列表
  currentChannelList.value = channelList.filter((item1) => {
    return props.orderData?.channel?.some((item2) => item2.channelCode === item1.id);
  });
});

return (_ctx: any,_cache: any) => {
  return (currentChannelList.value.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "支付方式：", -1)),
        _createVNode(_unref(Row), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentChannelList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "channel"
              }, [
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "channel-item",
                      onClick: ($event: any) => (toPay(item.id))
                    }, [
                      _createElementVNode("img", {
                        src: item?.img,
                        class: "pay-icon"
                      }, null, 8, _hoisted_2),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 8, _hoisted_1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode("当前商户没有可支持的支付方式，请联系商户开通")
      ], 64))
}
}

})